module.exports = __webpack_public_path__ + "img/module1.png";